import { Branch } from "../base/branch";
import { Client } from "./client";

export class Club extends Branch {
    static _type: string = 'Club';

    override load(source?: any): void {
        super.load(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new Client(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Club(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Club;
    }
}
